import { FC } from "react";
import { Route, Routes } from "react-router-dom";
import ResetPassword from "./reset-password";
import ResetPasswordSubmit from "./reset-password-submit";

const ResetPasswordModule: FC = () => {
  return (
    <Routes>
      <Route index path="/" element={<ResetPassword />} />
      <Route path="submit" element={<ResetPasswordSubmit />} />
    </Routes>
  );
};

export default ResetPasswordModule;
